// Valida el RUT en largo
export function validateRut(rut) {
  if (!rut) return "El RUT es obligatorio";

  let cleanRut = rut.replace(/\./g, "").replace(/-/g, "").toUpperCase();

  if (!/^\d{7,8}[0-9K]$/.test(cleanRut)) {
    return "Formato de RUT inválido";
  }

  let body = cleanRut.slice(0, -1);
  let dv = cleanRut.slice(-1);

  return "";
}

//Valida que el pasaporte sea alfanumerico y entre 5 y 15 caracteres
export function validatePasaporte(pasaporte) {
  if (!pasaporte) return "El pasaporte es obligatorio";

  if (!/^[A-Z0-9]{5,15}$/.test(pasaporte)) {
    return "Formato de pasaporte inválido (usa entre 5 y 15 caracteres alfanuméricos)";
  }

  return "";
}


// Valida que haya un motivo seleccionado
export function validateMotivo(motivo) {
  if (!motivo) return "Debes seleccionar un motivo de atención";
  return "";
}
